import { useQuery } from "@tanstack/react-query";
import { roleApi } from "@repo/api";
import { userQueryKeys } from "../../../pages/IspmUsers/queryKeys";

export const useGetRbacRoles = () => {
  const { data, isLoading, isError, error, isSuccess } = useQuery({
    queryKey: [userQueryKeys.roles()],
    queryFn: () => roleApi.getRoles(true),
  });

  return { data, isLoading, isError, error, isSuccess };
};
